module.exports = __webpack_public_path__ + "img/201110-5.ec478721.png";